import { App, customerAppList } from "contexts/CurrentAppContext";
import { QuickNavPage } from "constants/quickNav/types";

const toAppQuickNavPage = ({
  name,
  redirectUrl,
  AppSymbol,
}: App): QuickNavPage => ({
  name,
  path: redirectUrl,
  icon: AppSymbol,
});

export const APPS_QUICK_NAV_PAGES: QuickNavPage[] =
  customerAppList.map(toAppQuickNavPage);
